import React, { Suspense, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';

import LoadingScreen from '../../../components/LoadingScreen';
import * as ROUTES from '../../../constants/routes';

const ViewParentComponent = React.lazy(() => import('./components/ViewParent'));

const mapParent = (parent) => ({
  id: parent?.id,
  address: parent?.address,
  country: parent?.country,
  phone: parent?.phone,
  customerId: parent?.customer_id,
  faceImage: parent?.face_image,
  profileImage: parent?.profile_image ? parent?.profile_image : '',
  idImage: parent?.id_image,
  meansOfId: parent?.means_of_id,
  name: `${parent.first_name} ${parent?.last_name}`,
  gender: parent?.gender,
  dob: parent?.dob,
  email: parent?.email,
  kycTier: parent?.kyc_tier,
  isBvnVerified: parent?.is_bvn_verified,
  isNinVerified: parent?.is_nin_verified,
  userId: parent?.user_id,
  createdAt: parent?.created_at,
  user: parent?.user,
});

const ViewParent = () => {
  const { id } = useParams();
  const { pathname } = useLocation();

  const store = useSelector((state) => ({
    parentsList: state.app.parentsList,
  }), shallowEqual);

  const [parent, setParent] = useState(
    store.parentsList.find((p) => id === p.userId)
  );
  const [loading, setLoading] = useState(!parent);

  useEffect(() => {
    const fetchParent = async () => {
      try {
        const authToken = JSON.parse(localStorage.getItem(process.env.REACT_APP_ADMIN_AUTH_TOKEN));
        const response = await fetch(`${ROUTES.ADMIN_API}/users/parents/by-user/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${authToken.token}`,
          },
        });
        const data = await response.json();
        if (data?.data) {
          setParent(mapParent(data.data));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (!parent) {
      fetchParent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      {loading ? (
        <LoadingScreen isDashboard={pathname.includes('/dashboard')} />
      ) : (
        parent && (
          <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <ViewParentComponent parent={parent} />
          </Suspense>
        )
      )}
    </>
  );
};

export default ViewParent;
